
import BackendHeader from '../component/BackendHeader';
function About() {
    return (
        <div className="container-fluid p-0 web-cover" >
            <BackendHeader />

            <div className="table-responsive">
                <div className="d-none">
                    <h1>Trang Giới Thiệu</h1>
                    <p>Row 1</p>
                    <p>Row 12</p>
                    <p>Row 13</p>
                    <p>Row 14</p>
                    <p>Row 15</p>
                    <p>Row 16</p>
                    <p>Row 17</p>
                    <p>Row 18</p>
                    <p>Row 19</p>
                    <p>Row 1</p>
                    <p>Row 1</p>
                    <p>Row 1</p>
                    <p>Row 1</p>
                    <p>Row 30</p>
                    <p>Row 31</p>
                    <p>Row 32</p>
                    <p>Row 33</p>
                    <p>Đây là nội dung trang About.</p>
                </div>
            </div>
        </div>
    );
}

export default About;